import { api } from "@/lib/api";

const b64ToUint8 = (s) => {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isStandaloneIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.navigator.standalone;

export async function getPushState() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return sub ? "on" : "off";
}

export async function enablePush() {
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.enabled) throw new Error("Push not configured on server");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission was not granted");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.public_key) });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) {
    await api.post("/push/unsubscribe", { subscription: sub.toJSON() }).catch(() => {});
    await sub.unsubscribe();
  }
}

export async function resyncPush() {
  try {
    if (!pushSupported()) return;
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    if (sub) await api.post("/push/subscribe", { subscription: sub.toJSON() });
  } catch (_e) { /* ignore */ }
}
